import { ExtendedGameData, GameData } from '@/lib/drupal/models/Games';
import { createComponent, For, IntrinsicProps } from 'react-commons';
import SwGameRow from '../SwGameRow';

interface GameListProps extends IntrinsicProps {
  games: ExtendedGameData[]
  isDownloadGame?: boolean
}

export default createComponent<GameListProps>('GameList', {}, function GameList ({}, props) {
  return (
    <>
      {
        For(props.games, (game: ExtendedGameData, index: number) => (
          <SwGameRow 
            {...game}
            key={`${game.uid}_${index}`}
            className='Block'       
            useSmallImg     
            isDownloadGame={props.isDownloadGame}
          />
        ))
      }
    </>
  );
});
